import {inject, Injectable} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {first, Observable} from 'rxjs';
import {distinctUntilChanged, filter, map} from 'rxjs/operators';
import {PaymentMethod} from '@features/payment/domain/model/payment.model';
import {PaymentRoute, PaymentRefundParams} from '@features/payment/domain/ports/navigation/route.port';

@Injectable({providedIn: 'root'})
export class RefundRouteHandler implements PaymentRoute {
  private readonly route = inject(ActivatedRoute);

  getParams(): Observable<PaymentRefundParams> {
    return this.route.queryParamMap.pipe(
      first(),
      map((pm) => {
        const invoiceId = pm.get('invoiceId')?.trim() || '';
        const type = (pm.get('type')?.trim() as PaymentMethod) || PaymentMethod.CARD;

        return {
          invoiceId,
          type
        };
      }),
      filter(({invoiceId}) => !!invoiceId),
      distinctUntilChanged((a, b) => a.invoiceId === b.invoiceId && a.type === b.type)
    );
  }
}
